import {planTypes} from "@/common/constants";

export default {
  data () {
    return {
      logo: require('@/assets/plans/logo_docs.svg'),
      title: this.$t('billing.zoom_docs.title'),
      planType: planTypes.ZOOM_DOCS,
    }
  }
};
